<!-- 捐赠证书页面
捐赠成功页面点击查看证书跳转至该页面
我的捐赠页面点击我的证书跳转至该页面-->
<template>
  <div class="certificateDiv">
    <div class="imgBox">
      <img :src="donationData" class="image" alt="证书图片" />
      <div class="textBox">
        <div>尊敬的校友:</div>
        <div>
          感谢您对沈阳工程学院的爱心捐赠，对您给予学校的支持与厚爱表示崇高的敬意！
        </div>
        <div>呈此证书，以示纪念</div>
        <div>沈阳工程学院财务处</div>
        <div>{{ riqi }}</div>
        <div>证书编号:{{ bianma }}</div>
      </div>
    </div>
    <div class="bottom">
      <van-button block class="donating" @click="saveCert">保存证书</van-button>
    </div>
  </div>
</template>

<script>
import download from "@/utils/download";

export default {
  data() {
    return {
      certificate: "",
      imgUrl: "",
      show: false,
      display: 1,
      donation: "",
      donateId: window.localStorage.getItem("donateId"),
      openid: window.localStorage.getItem("openid"),
      donationData: "",
      riqi: "",
      bianma: "",
    };
  },
  created() {
    this.getDonationData();
    this.getCurrentDate();
    this.getRandomDigitString();
  },
  methods: {
    saveCert() {
      download(this.donationData);
    },
    async getDonationData() {
      const result = await this.$http.get("/donates/getCertificate", {
        params: { donateId: this.donateId, openid: this.openid },
      });
      this.donationData = result.data;
    },
    getCurrentDate() {
      const currentDate = new Date();
      const year = currentDate.getFullYear();
      const month = currentDate.getMonth() + 1;
      const day = currentDate.getDate();
      this.riqi = year + "年" + month + "月" + day + "日";
    },
    getRandomDigitString() {
      let result = "";
      for (let i = 0; i < 16; i++) {
        result += Math.floor(Math.random() * 10);
      }
      this.bianma = result;
    },
  },
};
</script>

<style lang="less" scoped>
.certificateDiv {
  padding-bottom: 3.43rem;
}
.imgBox {
  position: relative;
  width: 99vw;
  height: 75vh;
}
.textBox {
  position: absolute;
  left: 15%;
  right: 13%;
  top: 28%;
  font-size: 16px;
  font-weight: bold;
}
.textBox :nth-child(2) {
  margin-top: 20px;
  line-height: 25px; //行间距
  text-indent: 4ch; //首行缩进
  text-align: justify; //两端对齐
}

.textBox :nth-child(3) {
  margin-top: 20px;
  text-align: center;
}

.textBox :nth-child(4) {
  margin-top: 30px;
  text-align: right;
  font-weight: 500;
}
.textBox :nth-child(5) {
  margin-top: 10px;
  text-align: right;
  font-weight: 500;
}
.textBox :nth-child(6) {
  margin-top: 60px;
  text-align: center;
  font-weight: 500;
}

.image {
  width: 100%;
  height: 100%;
  min-height: 200px;
}

.bottom {
  position: fixed;
  bottom: 0;
  width: 100%;
  padding-bottom: env(safe-area-inset-bottom);
  background-color: #fff;
}

.donating {
  height: 3.43rem;
  line-height: 3.43rem;
  background: linear-gradient(270deg, #00706e, #00706e);
  font-size: 1.22rem;
  color: #ffffff;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/donation/Certificate.vue